import React from "react";
import useTranslationCommon from "../useTranslationCommon.js";
import useShowLoader from "../loading-widgets/useShowLoader.js";
import DateUtils from "../../../utils/DateUtils.js";
import StringUtils from "../../../utils/StringUtils.js";

export default function DisplayDate(props) {
  const { date } = props;
  const { t, loading: tLoading } = useTranslationCommon();
  const dateCalculator = DateUtils.dateDiff(Date.parse(date));
  useShowLoader(tLoading);

  return (
    <>
      {dateCalculator === 0 ? (
        <span>{t("common:common_today")}</span>
      ) : (
        <span>
          {t("common:common_period_days", {
            count: StringUtils.nullToZero(dateCalculator),
          })}
        </span>
      )}
    </>
  );
}
